const menuDataInitialState = {
  isLoading: false,
  error: null,
  data: null,
}

export default menuDataInitialState
